<template>
    <div id="school-map-header" class="school-map-header">
        <v-layout class="app-logo-desktop-wrapper align-center" row wrap>
          <a v-show="!isFrench" href="https://www.fraserinstitute.org" target="_blank">
            <img v-show="!isFrench" alt="logo" class="app-logo-desktop hidden-sm-and-down"
                src="@/assets/images/logo.png"
            />
          </a>

          <a v-show="isFrench" href="https://www.fraserinstitute.org/fr" target="_blank">
            <img v-show="isFrench" alt="logo" class="app-logo-desktop hidden-sm-and-down logo-fr"
                src="@/assets/images/logo-fr.png"
            />
          </a>
          <router-link class="map-header-title-link" :to="{name: 'home'}">
            <h1 class="map-header-title hidden-sm-and-down">School Rankings</h1>
          </router-link>
        </v-layout>
    </div>
</template>
<script>
  export default {
    computed: {
      isFrench() {
        return this.$store.state.currentLanguage === 'fr';
      }
    }
  }
</script>
